var _path, _path2, _path3, _rect, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _g, _path12, _path13, _g2, _path14, _path15, _path16, _g3, _path17, _path18, _path19, _path20, _path21, _path22, _g4, _path23, _g5, _path24, _path25, _path26, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImg4MetuaaGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 51,
    viewBox: "0 0 73 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.0353 45.6948H62.9084V48.562H72.0353V45.6948Z",
    fill: "url(#paint0_linear_3282_1575)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5334 45.6948H7.18576V48.562H64.5334V45.6948Z",
    fill: "#1D0C17"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 48.5571H8.07592V45.6899H0V48.5571Z",
    fill: "url(#paint1_linear_3282_1575)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30.0334,
    y: 45.25,
    width: 1.4375,
    height: 0.8125,
    fill: "#1D0C17"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2425 32.6744H24.0587C22.1883 32.6744 20.6699 35.666 20.6699 39.3565C20.6699 43.0469 22.1883 46.0385 24.0587 46.0385H29.2425C31.1128 46.0385 32.6312 43.0469 32.6312 39.3565C32.6312 35.666 31.1128 32.6744 29.2425 32.6744Z",
    fill: "#1D0C17"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2167 32.6744H32.0329C30.1626 32.6744 28.6441 35.666 28.6441 39.3565C28.6441 43.0469 30.1626 46.0385 32.0329 46.0385H37.2167C39.087 46.0385 40.6055 43.0469 40.6055 39.3565C40.6055 35.666 39.087 32.6744 37.2167 32.6744Z",
    fill: "#1D0C17"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88478 32.6744H4.0178C2.26307 32.6744 0.835152 35.666 0.835152 39.3565C0.835152 43.0469 2.25804 46.0385 4.0178 46.0385H8.88478C10.6395 46.0385 12.0624 43.0469 12.0624 39.3565C12.0624 35.666 10.6395 32.6744 8.88478 32.6744Z",
    fill: "#1D0C17"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4191 32.6744H62.2354C60.365 32.6744 58.8466 35.666 58.8466 39.3565C58.8466 43.0469 60.365 46.0385 62.2354 46.0385H67.4191C69.2895 46.0385 70.8079 43.0469 70.8079 39.3565C70.8079 35.666 69.2895 32.6744 67.4191 32.6744Z",
    fill: "#1D0C17"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.845951 39.4376C0.827268 39.0172 0.44751 30.3202 0.549072 30.0311C0.650635 29.7421 9.98574 30.8341 9.98574 30.8341L9.33212 38.2653C9.33212 38.2653 7.49694 37.7726 7.37124 37.7726C7.24555 37.7726 5.12379 34.3838 5.12379 34.3838L3.69587 33.7301L2.42884 34.5447L0.87523 39.3061C0.87523 39.3061 0.864633 39.858 0.845951 39.4376Z",
    fill: "#1D0C17"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0319 43.8214H8.75899V40.3522H28.9308L30.0319 43.8214Z",
    fill: "#1D0C17"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7666 43.8214H36.8497V40.3522H67.6655L68.7666 43.8214Z",
    fill: "#1D0C17"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2362 33.3283V30.6736L30.9268 29.9395L26.7637 31.2065V41.6595L28.8855 41.212L29.0464 38.678L29.4989 35.9026L30.8061 33.9819L36.2362 33.3283Z",
    fill: "#1D0C17"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0865 42.4735H70.2951L70.846 40.3749C71.027 39.7615 70.9397 40.7343 71.2678 39.8281C72.1116 37.1718 72.067 32.7088 72.0217 32.1054C72.0016 31.854 71.4666 31.015 70.9738 30.482C70.6018 30.0798 68.957 29.2666 65.3772 27.8437C61.4907 26.3001 52.9084 24.6874 52.9084 24.6874L46.2468 20.0894C46.2468 20.0894 47.2272 19.7727 46.835 19.3101C46.4428 18.8475 43.6222 17.5403 37.5033 17.2839C37.5033 17.2839 18.4074 17.1934 15.8784 17.5051C13.3494 17.8118 31.857 28.7122 33.0938 29.743C33.31 29.924 34.5117 31.5429 34.6575 31.7742C35.6178 33.3379 36.9301 35.0826 37.3575 37.9585C37.7848 40.8395 38.0815 42.4735 38.0815 42.4735H38.0865Z",
    fill: "#E7E5E5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3282_1575",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 17,
    width: 58,
    height: 26
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0865 42.4736H70.2951L70.846 40.375C71.027 39.7616 70.9397 40.7344 71.2678 39.8281C72.1116 37.1719 72.067 32.7088 72.0217 32.1055C72.0016 31.8541 71.4666 31.0151 70.9738 30.4821C70.6018 30.0799 68.957 29.2666 65.3772 27.8438C61.4907 26.3002 52.9084 24.6875 52.9084 24.6875L46.2468 20.0895C46.2468 20.0895 47.2272 19.7727 46.835 19.3102C46.4428 18.8476 43.6222 17.5404 37.5033 17.2839C37.5033 17.2839 18.4074 17.1934 15.8784 17.5052C13.3494 17.8119 31.857 28.7123 33.0938 29.743C33.31 29.924 34.5117 31.543 34.6575 31.7743C35.6178 33.3379 36.9301 35.0826 37.3575 37.9586C37.7848 40.8395 38.0815 42.4736 38.0815 42.4736H38.0865Z",
    fill: "#E7E5E5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3282_1575)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M71.9709 36.5105H37.4765V41.125H71.9709V36.5105Z",
    fill: "url(#paint2_linear_3282_1575)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2209 24.1181L22.8355 3.625L10.9109 29.896L59.2964 50.3891L71.2209 24.1181Z",
    fill: "url(#paint3_linear_3282_1575)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6303 27.0935C29.5744 26.4701 28.7398 25.3489 27.7845 23.941C26.8292 22.5332 25.0343 19.8031 22.8723 18.5109C21.6053 17.7568 19.2321 17.2389 15.6472 17.5305C13.1484 17.7366 9.17133 19.1042 7.34621 20.3662C5.52109 21.6282 5.55629 21.588 3.54011 22.6439C1.60438 23.6545 0.101044 23.8807 0.101044 23.8807L0.608859 33.6096C1.53902 31.3974 2.98202 30.4723 4.3144 30.8896C5.8831 31.3823 7.5976 33.856 8.64843 38.3811C9.23669 40.9101 9.14619 41.6894 9.82495 41.6894H28.2672C27.4476 38.9191 27.5985 34.8867 28.4733 33.0817C29.323 31.322 31.1934 29.9292 33.5515 31.4175C35.9096 32.9007 37.0207 37.5867 37.1313 42.4738H38.9514C39.3386 39.4068 39.5296 34.7208 37.966 31.9555C36.2615 28.9438 32.4705 27.9533 30.6404 27.0935H30.6303Z",
    fill: "#B9B2B4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3282_1575",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 17,
    width: 40,
    height: 26
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6303 27.0935C29.5744 26.4701 28.7398 25.3489 27.7845 23.941C26.8292 22.5332 25.0343 19.8031 22.8723 18.5109C21.6053 17.7568 19.2321 17.2389 15.6472 17.5305C13.1484 17.7366 9.17133 19.1042 7.34621 20.3662C5.52109 21.6282 5.55629 21.588 3.54011 22.6439C1.60438 23.6545 0.101044 23.8807 0.101044 23.8807L0.608859 33.6096C1.53902 31.3974 2.98202 30.4723 4.3144 30.8896C5.8831 31.3823 7.5976 33.856 8.64843 38.3811C9.23669 40.9101 9.14619 41.6894 9.82495 41.6894H28.2672C27.4476 38.9191 27.5985 34.8867 28.4733 33.0817C29.323 31.322 31.1934 29.9292 33.5515 31.4175C35.9096 32.9007 37.0207 37.5867 37.1313 42.4738H38.9514C39.3386 39.4068 39.5296 34.7208 37.966 31.9555C36.2615 28.9438 32.4705 27.9533 30.6404 27.0935H30.6303Z",
    fill: "#B9B2B4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3282_1575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.3637 28.8118H-2.19273V42.6589H38.3637V28.8118Z",
    fill: "url(#paint4_linear_3282_1575)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7143 52.425L2.59595 21.075L22.3515 6.29517L45.2688 37.0951L21.7143 52.425Z",
    fill: "url(#paint5_linear_3282_1575)"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.44236 26.6312H25.6628C25.6628 26.6312 27.5131 26.7418 27.317 25.7413C27.1209 24.7407 25.0997 21.3318 23.0735 19.8134C20.7908 18.1039 14.7121 18.2196 12.1982 19.3458C8.70381 20.6531 6.31557 22.5787 4.90274 23.3329C4.90274 23.3329 4.34465 26.6262 8.44739 26.6262L8.44236 26.6312Z",
    fill: "#16A34A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7858 19.3604C46.1813 17.9676 44.5171 17.8269 42.0183 17.4699C40.0675 17.1883 32.8625 17.1682 27.9352 17.1682C23.0079 17.1682 19.4783 17.2034 17.9348 17.3744C20.9414 17.3744 23.7269 17.6308 25.6978 19.7978C27.6687 21.9648 30.0771 25.062 30.7558 25.8262C31.4296 26.5904 32.1335 26.696 37.5686 26.696H61.7728C61.7728 26.696 51.4003 20.7531 48.7908 19.3604H48.7858Z",
    fill: "#16A34A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3282_1575",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 17,
    width: 58,
    height: 10
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M8.44236 26.6307H25.6628C25.6628 26.6307 27.5131 26.7413 27.317 25.7407C27.1209 24.7402 25.0997 21.3313 23.0735 19.8129C20.7908 18.1034 14.7121 18.219 12.1982 19.3453C8.70381 20.6525 6.59211 22.4626 4.90274 23.3324C4.90274 23.3324 4.34465 26.6256 8.44739 26.6256L8.44236 26.6307ZM61.768 26.696H37.5638C32.1287 26.696 31.4298 26.5904 30.751 25.8262C30.0773 25.062 27.6639 21.9648 25.693 19.7978C23.7221 17.6308 20.9366 17.3693 17.93 17.3744C19.4735 17.2034 23.0031 17.1682 27.9304 17.1682C32.8577 17.1682 40.0627 17.1883 42.0135 17.4699C44.5123 17.8269 46.1766 17.9676 48.781 19.3604C51.3854 20.7531 61.763 26.696 61.763 26.696H61.768Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3282_1575)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.84594,
    y: 29.6249,
    width: 11.625,
    height: 63,
    transform: "rotate(-90 3.84594 29.6249)",
    fill: "url(#paint6_linear_3282_1575)"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3621 25.9069H24.8821C24.6207 25.9069 24.0437 25.4579 24.0539 24.6966C24.0641 23.9353 24.4084 23.4282 24.4084 23.4282H20.8459C20.8459 23.4282 20.2053 24.7411 20.2053 25.6562C20.2053 26.5713 21.8465 27.3398 21.8465 27.3398H26.2053C27.2008 27.3398 27.3571 25.9069 27.3571 25.9069H27.3621Z",
    fill: "#CFCBCC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2651 42.7956H36.3621V39.0046H71.517C71.517 39.0046 70.8785 41.5185 70.2651 42.7956Z",
    fill: "#1D0C17"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6241 39.8944H8.15057V42.2927H28.6241V39.8944Z",
    fill: "#1D0C17"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M2.07191 25.7964C1.4736 25.8467 0.674166 25.8919 0.201546 25.8165L0.473051 31.136C0.473051 31.136 1.36801 31.0254 1.6546 30.3919C1.93616 29.7734 2.11214 28.0388 2.07191 25.7964Z",
    fill: "#5C4D53"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8948 30.3225C64.2294 30.8227 64.5271 31.4287 64.7629 31.9875C64.8113 32.1021 64.8542 32.215 64.8967 32.3225C61.4526 32.3307 57.2587 32.3403 53.4856 32.3372C53.4202 32.1657 53.3467 31.9793 53.2649 31.7854C53.0726 31.3298 52.8302 30.8198 52.55 30.3499C56.6811 30.3517 60.6928 30.3374 63.8948 30.3225ZM39.3079 30.261C43.0653 30.3241 47.5485 30.3451 51.9358 30.3489C52.2632 30.844 52.5547 31.4385 52.7864 31.9875C52.8367 32.1069 52.881 32.2245 52.925 32.3362C48.8578 32.3317 45.3609 32.3171 43.9543 32.2776C39.6605 32.1619 39.3079 30.2659 39.3079 30.2659V30.261ZM70.762 30.301C72.1037 31.2886 72.0334 32.3059 72.0334 32.3059C71.9942 32.3061 69.2421 32.3122 65.4553 32.3215C65.3914 32.1545 65.3208 31.9733 65.2415 31.7854C65.045 31.3199 64.7961 30.7978 64.5081 30.3196C68.2253 30.3018 70.7091 30.2868 70.762 30.301Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_3282_1575",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 33,
    width: 6,
    height: 12
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2991 39.2543C29.2991 36.2286 30.3604 33.7812 31.6663 33.7812C32.9721 33.7812 34.0334 36.2338 34.0334 39.2543C34.0334 42.2748 32.9721 44.7273 31.6663 44.7273C30.3604 44.7273 29.2991 42.2748 29.2991 39.2543Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_3282_1575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.0334 39.2543C34.0334 42.2799 32.9721 44.7273 31.6663 44.7273C30.3604 44.7273 29.2991 42.2748 29.2991 39.2543C29.2991 36.2338 30.3604 33.7812 31.6663 33.7812C32.9721 33.7812 34.0334 36.2338 34.0334 39.2543Z",
    fill: "#746A6E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M30.5061 48.2228L38.7434 43.6709L32.9436 31.9741L24.7063 36.526L30.5061 48.2228Z",
    fill: "url(#paint7_linear_3282_1575)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M32.9526 39.4091C32.9526 41.6913 32.2532 43.5397 31.3875 43.5397C30.5219 43.5397 29.8225 41.6913 29.8225 39.4091C29.8225 37.127 30.5219 35.2786 31.3875 35.2786C32.2532 35.2786 32.9526 37.127 32.9526 39.4091Z",
    fill: "#746A6E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_3282_1575",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 33,
    width: 6,
    height: 12
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1.73657 39.2543C1.73657 36.2286 2.79789 33.7812 4.10376 33.7812C5.40962 33.7812 6.47095 36.2338 6.47095 39.2543C6.47095 42.2748 5.40962 44.7273 4.10376 44.7273C2.79789 44.7273 1.73657 42.2748 1.73657 39.2543Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_3282_1575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.47095 39.2543C6.47095 42.2799 5.40962 44.7273 4.10376 44.7273C2.79789 44.7273 1.73657 42.2748 1.73657 39.2543C1.73657 36.2338 2.79789 33.7812 4.10376 33.7812C5.40962 33.7812 6.47095 36.2338 6.47095 39.2543Z",
    fill: "#746A6E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M2.94357 48.2228L11.1809 43.6709L5.38108 31.9741L-2.8562 36.526L2.94357 48.2228Z",
    fill: "url(#paint8_linear_3282_1575)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M5.39012 39.4091C5.39012 41.6913 4.69072 43.5397 3.82504 43.5397C2.95935 43.5397 2.25996 41.6913 2.25996 39.4091C2.25996 37.127 2.95935 35.2786 3.82504 35.2786C4.69072 35.2786 5.39012 37.127 5.39012 39.4091Z",
    fill: "#746A6E"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0224 12.695L67.6733 11.5045L68.3242 12.695C68.9305 13.8243 69.8429 14.7311 70.9388 15.343L72.0959 15.9995L70.9221 16.6559C69.8095 17.2734 68.9139 18.1969 68.3075 19.3039L67.6566 20.4944L67.028 19.3039C66.4216 18.1746 65.5092 17.2678 64.4133 16.6559L63.2395 15.9995L64.4133 15.343C65.5092 14.7478 66.4216 13.8243 67.028 12.695H67.0224Z",
    fill: "#16A34A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6121 5.97476C66.9223 4.72307 65.9098 3.67164 64.6748 2.99851C65.9098 2.30312 66.9445 1.2517 67.6121 0C68.3019 1.2517 69.3144 2.30312 70.5494 2.97626C69.3144 3.67164 68.3019 4.70081 67.6121 5.97476Z",
    fill: "#16A34A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9087 4.33365L57.7988 2.67029L58.6889 4.33365C59.54 5.91357 60.7973 7.18752 62.3605 8.0498L63.9794 8.95658L62.3605 9.8578C60.8196 10.7201 59.5456 11.994 58.6889 13.5739L57.7988 15.2373L56.9087 13.5739C56.0575 11.994 54.8003 10.7201 53.2371 9.8578L51.5959 8.95658L53.2371 8.0498C54.8003 7.18752 56.0575 5.91357 56.9087 4.33365Z",
    fill: "#16A34A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3282_1575",
    x1: 62.9126,
    y1: 47.1259,
    x2: 72.0353,
    y2: 47.1259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#1D0C17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D0C17",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3282_1575",
    x1: 8.07592,
    y1: 47.126,
    x2: 0,
    y2: 47.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#1D0C17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D0C17",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3282_1575",
    x1: 54.7216,
    y1: 37.9911,
    x2: 54.7216,
    y2: 41.3306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#746A6E",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#746A6E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3282_1575",
    x1: 16.3805,
    y1: 16.5544,
    x2: 64.2538,
    y2: 40.4625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFCBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#CFCBCC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3282_1575",
    x1: 18.0855,
    y1: 33.254,
    x2: 18.0855,
    y2: 43.2704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#746A6E",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#746A6E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3282_1575",
    x1: 34.0921,
    y1: 19.9907,
    x2: 13.0847,
    y2: 30.4411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#746A6E",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#746A6E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3282_1575",
    x1: 3.84594,
    y1: 61.1249,
    x2: 15.4709,
    y2: 61.1249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.115385,
    stopColor: "#42003B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913462,
    stopColor: "#42003B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3282_1575",
    x1: 28.4324,
    y1: 41.1706,
    x2: 36.8629,
    y2: 36.9904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#CFCBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CFCBCC",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#CFCBCC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3282_1575",
    x1: 0.869937,
    y1: 41.1706,
    x2: 9.30039,
    y2: 36.9904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#CFCBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CFCBCC",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#CFCBCC",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg4MetuaaGreen);
export default __webpack_public_path__ + "static/media/img4_metuaa_green.6694e1a6af2fec82a6d53d3d0d808f0f.svg";
export { ForwardRef as ReactComponent };